// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-input-form_xyQ5U {\n  padding: 0 15px 40px;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://./src/components/SearchInput/SearchInput.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":[".search-input-form {\n  padding: 0 15px 40px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-input-form": "search-input-form_xyQ5U"
};
export default ___CSS_LOADER_EXPORT___;
